import {Injectable} from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    PRIMARY_OUTLET,
    Router,
    RouterStateSnapshot,
    UrlSegmentGroup,
    UrlTree
} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, mergeMap} from "rxjs/operators";
import {CampaignEventsService} from "../../booking-flow/services/campaign-events.service";
import {JobRequest} from "../../shared/_models/jobRequest";
import {AuthService} from "../_services/auth.service";
import {UserService} from "../_services/user.service";
import {UtilitiesService} from "../_services/utilities.service";

@Injectable({
    providedIn: 'root'
})
export class LandingPageDetailGuard implements CanActivate {

    constructor(private router: Router,
                private authService: AuthService,
                private utilitiesService: UtilitiesService,
                private campaignEventsService: CampaignEventsService,
                private userService: UserService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        // don't call backend if we have a pass-through
        if (route.queryParams.passThrough == "true") {
            return of(true);
        }
        const tree: UrlTree = this.router.parseUrl(state.url);
        const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
        let segments = g.segments;
        const dynamicUrl = UtilitiesService.isNotEmpty(segments[1]) ? segments[1] : segments[0];
        const isNewUserUrl = segments[2] && segments[2].path && segments[2].path == "newuser";
        const params = { url: dynamicUrl.path };
        const queryParams = route.queryParams;
        const getLandingPageDetail$ = this.userService.getLandingPageDetail(params, 'dynamic-flow-guard');
        const utmParams: string = this.campaignEventsService.utmParams();
        return getLandingPageDetail$.pipe(
            mergeMap((response: any) => {
                let allowed = response.responseCode === 100;
                if (!allowed || UtilitiesService.isEmpty(response.landingPageDetail)) {
                    this.router.navigate(['/book']);
                    return of(false);
                }
                this.campaignEventsService.landingPage = true;
                this.campaignEventsService.landingPageDetail = response.landingPageDetail;
                this.campaignEventsService.landingPageDetailId = response.landingPageDetail.id;
                this.campaignEventsService.partnerId = response.landingPageDetail.partnerId;

                let referrerId: number;
                if (this.campaignEventsService.landingPageDetail && this.campaignEventsService.landingPageDetail.id) {
                    referrerId = this.campaignEventsService.landingPageDetail.id;
                }

                this.utilitiesService.setLocal("referrerId", referrerId);
                this.utilitiesService.setLocal("referrerType", JobRequest.REFERRER_TYPE_LANDING_PAGE_DETAIL);

                // this is kind of a hack and hopefully we can remove when we port all landing page routes to dynamic booking flow
                if (dynamicUrl.path === 'carparts') {
                    this.router.navigate(['/book'], {queryParams: queryParams});
                } else if (dynamicUrl.path === 'carvana') {
                    this.router.navigate(['/book']);
                } else if (this.authService.loggedIn()) {
                    if (isNewUserUrl) {
                        if (response.landingPageDetail.singleService) {
                            this.router.navigate(['/p/' + dynamicUrl + '/s'], { queryParams: { passThrough: true } });
                        } else {
                            this.router.navigate(['/p/' + dynamicUrl], { queryParams: { passThrough: true } });
                        }
                        allowed = false;
                    } else {
                        this.router.navigate(['/p/' + dynamicUrl + '/s'], { queryParams: { passThrough: true } });
                    }
                } else {
                    if (!isNewUserUrl) {
                        if (response.landingPageDetail.singleService) {
                            this.router.navigate(['/p/' + dynamicUrl + '/s/newuser'], { queryParams: { passThrough: true } });
                        } else {
                            this.router.navigate(['/p/' + dynamicUrl + '/newuser'], { queryParams: { passThrough: true } });
                        }
                    }
                }
                if (!allowed) {
                    window.location.href = $localize`https://wrench.com/book?` + utmParams;
                }
                return of(allowed);
            }), catchError((error: any) => {
                UtilitiesService.consoleLog(error);
                window.location.href = $localize`https://wrench.com/book?` + utmParams;
                return of(false);
            })
        );
    }
}
